<template>
    <!-- Modal -->
    <div class="modal fade" id="changeOrderStatusModal" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="changeOrderStatusModalLabel">Change Order Status</h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Status</label>
                        <select class="form-control" v-model="selectedStatus">
                            <option v-for="status in updatedStatuses" v-bind:key="'statuses_'+status.id"
                                    v-bind:value="status.id">{{ status.name }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group" v-if="selectedStatus === 9">
                        <label>Cancel Reasons</label>
                        <select class="form-control" v-model="selectedCancelReason">
                            <option v-for="reason in allCancelReasons" v-bind:key="'cancel_reason_'+reason.id"
                                    v-bind:value="reason.id">{{ reason.reason }}
                            </option>
                        </select>

                        <label>Cancel Reasons</label>
                        <textarea class="form-control" rows="7" v-model="otherCancelReasons"></textarea>

                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" v-bind:disabled="disableButton" v-on:click="updateOrderStatus()"
                            class="btn btn-primary">Update Status
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChangeOrderStatus",
    data: function () {
        return {
            selectedStatus: -1,
            otherCancelReasons: "",
            disableButton: false,
            allCancelReasons: [],
            updatedStatuses: [],
            selectedCancelReason: -1
        }
    },
    created: function () {
        this.$http.get(this.$store.state.mainAppURL + "orders/get_all_order_cancellation_reasons").then(resp => {
            this.allCancelReasons = resp.data.filter(
                cancelReason => (cancelReason.id !== 5 && cancelReason.id !== 6)
            );
        });
    },
    mounted: function () {
        $("#changeOrderStatusModal").on('hidden.bs.modal', (e) => {
          this.selectedStatus = -1;
          this.otherCancelReasons = "";
          this.disableButton = false;
          this.selectedCancelReason = -1
        });
        $("#changeOrderStatusModal").on('shown.bs.modal', async (e) => {
          let testStatus = this.statuses && this.statuses.find(e=>e.id === 11)
          this.updatedStatuses = this.statuses && this.filteredStatusesAccToOrderCurrentStatus()
          if (this.restaurantId === 37 || this.restaurantId === 40) {
            this.updatedStatuses.push(testStatus)
          }
        });
    },
    props: {
        orderId: Number,
        currentStatusId: Number,
        orderTypeId: Number,
        statuses: Array,
        restaurantId: Number,
    },
    methods: {
        filteredStatusesAccToOrderCurrentStatus() {
          let loggedInRole = this.$store.getters.user.userRolesById[0].role;
          let isAdmin = (loggedInRole === 'ROLE_ADMIN');
          let isAgent = (loggedInRole === 'ROLE_AGENT')
          let isTakeAway = (this.orderTypeId === 1)
          switch (this.currentStatusId){
            case 27: // SCHEDULED
              if(isAgent || isAdmin){
                return this.statuses.filter(status => status.id === 7 || status.id === 9 || status.id === 11)  // 7 => UNASSIGNED, 9 => CANCELLED
              }
              break
            case 7: // UNASSIGNED
              if(isAgent || isAdmin){
                return this.statuses.filter(status => status.id === 2 || status.id === 9 || status.id === 11)  // 2 => ACCEPTED BY BRANCH, 9 => CANCELLED
              }
              break
            case 2: //ACCEPTED BY BRANCH
              if (isTakeAway) {
                return this.statuses.filter(status => status.id === 22 || status.id === 9 || status.id === 11)  // 22 => READY FOR PICKUP
              }else {
                return this.statuses.filter(status => status.id === 10 || status.id === 9 || status.id === 11) // 10 => READY FOR DELIVERY
              }
            case 10: //READY FOR DELIVERY
              if(isAdmin || isAgent) {
                return this.statuses.filter(status => status.id === 6 || status.id === 9 || status.id === 11) // 6 => DELIVERED
              }
              break
            case 22:  //READY FOR PICKUP
              if(isAdmin || isAgent){
                return this.statuses.filter(status => status.id === 19 || status.id === 9 || status.id === 11) //19 => PICKED BY CUSTOMER
              }
              break
            case 25: //ALFALAH PAYMENT FAILURE
              if(isAdmin) {
                return this.statuses.filter(status => status.id === 9 || status.id === 11) //9 => CANCELLED
              }
              break
            case 9: //CANCELED ORDER
              if(isAdmin || isAgent) {
                return this.statuses.filter(status => status.id === 11)
              }
              break
            case 6: //DELIVERED
              if(isAdmin || isAgent) {
                return this.statuses.filter(status => status.id === 11)
              }
              break
          }
        },
        updateOrderStatus: function () {

            let params = new URLSearchParams();
            if (this.selectedStatus === -1) {
                return swal("Error!", "Please select status", "error");
            } else if (this.selectedStatus === 9 && this.selectedCancelReason === -1) {
                return swal("Error!", "Please select cancel reason", "error");
            } else if (this.selectedCancelReason === 4 && this.otherCancelReasons === "") {
                return swal("Error!", "Please type cancel reasons", "error");
            } else if (this.selectedStatus === 9 && this.otherCancelReasons === "") {
                    this.otherCancelReasons = " "
            }
            if (this.selectedStatus === 9) {
                params.append("cancel_reason_id", this.selectedCancelReason);
                params.append("cancel_reasons", this.otherCancelReasons)

            }

            this.disableButton = true;
            params.append("status_id", this.selectedStatus);
            params.append("order_id", this.orderId);
            this.$http.post(this.$store.state.mainAppURL + "orders/update_order_status", params).then(resp => {
                if (resp.data) {
                    swal("SUCCESS!", "Status has been updated! Press Refresh Button To See The Update!", "success");
                    $("#changeOrderStatusModal").modal("hide");
                    $("#order_view_model").modal("hide");
                }

            });
        }
    }
}
</script>

<style scoped>

</style>
